<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="flex flex-col px-2 lg:px-8">
    <div class="mb-1 flex flex-col sm:flex-row sm:items-center sm:justify-between">
      <div class="mb-1 flex max-w-lg flex-col sm:mb-0 sm:mr-4 sm:max-w-none">
        <div class="flex items-center gap-8 text-center">
          <h1 class="pb-1 text-left text-title-md2 font-semibold text-black">
            {{ t('anomaly_detector.header.title') }}
          </h1>
        </div>

        <p class="max-w-prose text-left font-medium">
          {{ t('anomaly_detector.header.subtitle') }}
        </p>
      </div>
    </div>

  </div>
</template>
